import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import Common from '../../utilities/common';

export interface IErrorDialogProps {
    open: boolean;
    message?: string;
}

export interface IErrorDialogState {
    open: boolean
}

export default class ErrorDialog extends React.Component<IErrorDialogProps, IErrorDialogState> {
    public constructor(props: IErrorDialogProps) {
        super(props);

        this.state = {
            open: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IErrorDialogProps>, nextContext: any): void {
        this.setState(
            {
                open: nextProps.open
            }
        );
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Error
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={4} className='textCenter'>
                            <ErrorOutlinedIcon color='error' titleAccess={'Error'} style={{fontSize: '6em'}}/>
                        </Grid>
                        <Grid item xs={8}>
                            {
                                !Common.IsNullOrEmpty(this.props.message!) && (
                                    <React.Fragment>
                                        <Typography variant='body2' marginBottom={'10px'}>
                                            Ocurrió el siguiente error procesando la solicitud:
                                        </Typography>
                                        <Typography variant='body2' marginBottom={'10px'}>
                                            {
                                                this.props.message
                                            }
                                        </Typography>
                                    </React.Fragment>
                                )
                            }
                            {
                                Common.IsNullOrEmpty(this.props.message!) && (
                                    <React.Fragment>
                                        <Typography variant='body2' marginBottom={'10px'}>
                                            Ha ocurrido un error procesando la solicitud.
                                        </Typography>
                                    </React.Fragment>
                                )
                            }
                            <Typography variant='body2'>
                                Inténtelo de nuevo y si el problema persiste póngase en contacto con el administrador del sistema.
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        this.setState(
                            {
                                open: false
                            }
                        )
                    }}>Ok</Button>
                </DialogActions>
            </Dialog>
        )
    }
}